import { Link, useLocation } from "react-router-dom"
import { useForm } from "react-hook-form";
import Aside from "../../components/Aside"
import Footer from "../../components/Footer"
import Header from "../../components/Header"
import { useEffect, useState } from "react";
import { UsersService } from "../../services/UsersService";
import Button from "../../components/form-controls/Button";
import { AlertService } from "../../services/Alert";
import { useTranslation } from "react-i18next";
function SupervisorPermissionsPage() {

    const { state: { user } } = useLocation();

    const {t } = useTranslation();

    const defaultPermissions = {
        dashboard: {
            show: true,
            actions: true,
            download: true,
            show_ticket: true,
        },
        reports: {
            show: true,
            actions: true,
            download: true,
        },
        sends: {
            show: true,
            create: true,
            actions: true,
        },
        followup: {
            show: true,
            actions: true,
            download: true,
        },
        configuration: {
            show: true,
            actions: true,
            create: true,
            download: true,
        },
        channels: {
            show: true,
            actions: true,
            create: true,
            download: true,
        },
        user: {
            show: true,
            actions: true,
            create: true,
        },
        accounts: {
            show: true,
            actions: true,
        },
        accounts_db: {
            show: true,
            create: true,
            actions: true,
        },
        payments: {
            show: true,
            actions: true,
        },
        bots: {
            show: true,
            intentions: true,
            create: true,
        },
    }

    const { register, handleSubmit, setValue, watch, reset, formState: { isSubmitting } } = useForm({
        mode: 'onChange',
        defaultValues: {
            account_id: '',
            user_id: '',
            settings: defaultPermissions,
        }
    });

    const dashboardShow = watch('settings.dashboard.show')
    const reportsShow = watch('settings.reports.show')
    const userShow = watch('settings.user.show')
    const sendsShow = watch('settings.sends.show')
    const followupShow = watch('settings.followup.show')
    const configurationShow = watch('settings.configuration.show')
    const channelsShow = watch('settings.channels.show')
    const accountsShow = watch('settings.accounts.show')
    const dbShow = watch('settings.accounts_db.show')
    const paymentsShow = watch('settings.payments.show')
    const botsShow = watch('settings.bots.show')

    const getCurrentPermissions = async () => {

        const isObject = (item) => {
            return (item && typeof item === 'object' && !Array.isArray(item));
        }


        const mergeDeep = (target, ...sources) => {
            if (!sources.length) return target;
            const source = sources.shift();

            if (isObject(target) && isObject(source)) {
                for (const key in source) {
                    if (isObject(source[key])) {
                        if (!target[key]) Object.assign(target, { [key]: {} });
                        mergeDeep(target[key], source[key]);
                    } else {
                        Object.assign(target, { [key]: source[key] });
                    }
                }
            }

            return mergeDeep(target, ...sources);
        }


        try {
            const { data } = await UsersService.getCurrentPermissions({ account_id: user.account_id, user_id: user.id })

            const newObject = mergeDeep(defaultPermissions, data)

            reset({
                account_id: user.account_id,
                user_id: user.id,
                settings: newObject,
            })

        } catch (error) {
            console.error(error)
        }
    }

    const submit = async (data) => {
        try {
            await UsersService.saveUserPermissions(data);
            AlertService.success('¡Éxito!', "Se actualizarón correctamente los permisos");
        } catch (error) {
            console.log(error)
            AlertService.error('¡Error!', "Algo salio mal, intenta más tarde");
        }
    }

    useEffect(() => {
        getCurrentPermissions()
    }, [user])


    useEffect(() => {
        if (!dashboardShow) {
            setValue('settings.dashboard.actions', false)
            setValue('settings.dashboard.download', false)
        }
    }, [dashboardShow])

    useEffect(() => {
        if (!reportsShow) {
            setValue('settings.reports.actions', false)
            setValue('settings.reports.download', false)
        }
    }, [reportsShow])

    useEffect(() => {
        if (!userShow) {
            setValue('settings.user.actions', false)
            setValue('settings.user.create', false)
        }
    }, [userShow])

    useEffect(() => {
        if (!accountsShow) {
            setValue('settings.accounts.actions', false)
        }
    }, [accountsShow])

    useEffect(() => {
        if (!sendsShow) {
            setValue('settings.sends.actions', false)
            setValue('settings.sends.create', false)
        }
    }, [sendsShow])

    useEffect(() => {
        if (!followupShow) {
            setValue('settings.followup.actions', false)
            setValue('settings.followup.download', false)
        }
    }, [followupShow])

    useEffect(() => {
        if (!configurationShow) {
            setValue('settings.configuration.actions', false)
            setValue('settings.configuration.create', false)
            setValue('settings.configuration.download', false)
        }
    }, [configurationShow])

    useEffect(() => {
        if (!channelsShow) {
            setValue('settings.channels.actions', false)
            setValue('settings.channels.create', false)
            setValue('settings.channels.download', false)
        }
    }, [channelsShow])

    useEffect(() => {
        if (!dbShow) {
            setValue('settings.accounts_db.actions', false)
            setValue('settings.accounts_db.create', false)
        }
    }, [dbShow])

    useEffect(() => {
        if (!paymentsShow) {
            setValue('settings.payments.actions', false)
        }
    }, [paymentsShow])

    useEffect(() => {
        if (!botsShow) {
            setValue('settings.bots.intentions', false)
            setValue('settings.bots.create', false)
        }
    }, [botsShow])

    return (
        <>
            <Header />
            <Aside />

            <main id="content" role="main" className="main">

                <div className="content container-fluid">

                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col-sm mb-2 mb-sm-0 d-flex align-items-center">
                                <Link to={`/users`} className="breadcrumb-link">
                                    <button type="button" className="btn btn-soft-primary btn-icon me-3">
                                        <i className="bi-chevron-left"></i>
                                    </button>
                                </Link>

                                <h2 className="page-header-title m-0 me-3 text-dark">{t('platform.users.supervisor.permissions-title')}</h2>
                            </div>

                            <div className="col-sm-auto">
                                <Button className="btn btn-primary btn-sm" isLoading={isSubmitting} onClick={handleSubmit(submit)}>{t('btn-save')}</Button>
                            </div>
                        </div>
                    </div>
                    <div className="row d-flex justify-content-center">
                        <div className="col-7">
                            <div className="card">
                                <div className="card-header">
                                    <h4 className="card-title">{t('platform.users.supervisor.config-label')}</h4>
                                    <p>{t('platform.users.supervisor.config-text')} <b>{user?.fullname}</b>.</p>
                                </div>
                                {<div className="accordion accordion-flush" id="accordionFlushExample">
                                    <div className="accordion-item">
                                        <h2 className="accordion-header">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#Dashboard" aria-expanded="false" aria-controls="Dashboard">
                                                <i className="me-2 bi-speedometer2"></i> {t("components.aside.dashboard")}
                                                <span className="ms-3 opacity-75 fw-lighter">
                                                    {watch('settings.dashboard.show') ? t('platform.users.supervisor.watch') + ', '  : ''}
                                                    {watch('settings.dashboard.actions') ? t('platform.users.supervisor.interactions') + ', ' : ''}
                                                    {watch('settings.dashboard.download') ? t('platform.users.supervisor.download-export') : ''}
                                                </span>
                                            </button>
                                        </h2>
                                        <div id="Dashboard" className="accordion-collapse collapse ps-5" data-bs-parent="#accordionFlushExample">
                                            <div className="form-check">
                                                <input className="form-check-input " type="checkbox" {...register('settings.dashboard.show')} />
                                                <label className="form-check-label">{t('platform.users.supervisor.watch')}</label>
                                            </div>
                                            <div className="form-check">
                                                <input className="form-check-input" type="checkbox"  {...register('settings.dashboard.actions')} disabled={!dashboardShow} />
                                                <label className="form-check-label">{t('platform.users.supervisor.interactions')}</label>
                                            </div>
                                            <div className="form-check">
                                                <input className="form-check-input" type="checkbox"  {...register('settings.dashboard.download')} disabled={!dashboardShow} />
                                                <label className="form-check-label">{t('platform.users.supervisor.download-export')}</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="accordion-item">
                                        <h2 className="accordion-header">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#Reports" aria-expanded="false" aria-controls="Reports">
                                                <i className="bi-grid-1x2 nav-icon"></i> {t("components.aside.reports.reports-title")}
                                                <span className="ms-3 opacity-75 fw-lighter">
                                                    {watch('settings.reports.show') ? t('platform.users.supervisor.watch') + ', ' : ''}
                                                    {watch('settings.reports.actions') ? t('platform.users.supervisor.interactions') + ', ' : ''}
                                                    {watch('settings.reports.download') ?  t('platform.users.supervisor.download-export') : ''}
                                                </span>
                                            </button>
                                        </h2>
                                        <div id="Reports" className="accordion-collapse collapse ps-5" data-bs-parent="#accordionFlushExample">
                                            <div className="form-check">
                                                <input className="form-check-input " type="checkbox" {...register('settings.reports.show')} />
                                                <label className="form-check-label">{t('platform.users.supervisor.watch')}</label>
                                            </div>
                                            <div className="form-check">
                                                <input className="form-check-input" type="checkbox"  {...register('settings.reports.actions')} disabled={!reportsShow} />
                                                <label className="form-check-label">{t('platform.users.supervisor.interactions')}</label>
                                            </div>
                                            <div className="form-check">
                                                <input className="form-check-input" type="checkbox"  {...register('settings.reports.download')} disabled={!reportsShow} />
                                                <label className="form-check-label">{t('platform.users.supervisor.download-export')}</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="accordion-item">
                                        <h2 className="accordion-header">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#clients_bd" aria-expanded="false" aria-controls="clients_bd">
                                                <i className="me-2 bi-person-bounding-box"></i> {t("components.aside.customer-base")}
                                                <span className="ms-3 opacity-75 fw-lighter">
                                                    {watch('settings.accounts_db.show') ? t('platform.users.supervisor.watch') + ', ' : ''}
                                                    {watch('settings.accounts_db.actions') ? t('platform.users.supervisor.interactions') + ', ' : ''}
                                                    {watch('settings.accounts_db.create') ?   t('platform.users.supervisor.create') : ''}
                                                </span>
                                            </button>
                                        </h2>
                                        <div id="clients_bd" className="accordion-collapse collapse ps-5" data-bs-parent="#accordionFlushExample">
                                            <div className="form-check">
                                                <input className="form-check-input " type="checkbox"  {...register('settings.accounts_db.show')} />
                                                <label className="form-check-label">{t('platform.users.supervisor.watch')}</label>
                                            </div>
                                            <div className="form-check">
                                                <input className="form-check-input" type="checkbox"   {...register('settings.accounts_db.actions')} disabled={!dbShow} />
                                                <label className="form-check-label">{t('platform.users.supervisor.interactions')}</label>
                                            </div>
                                            <div className="form-check">
                                                <input className="form-check-input" type="checkbox"  {...register('settings.accounts_db.create')} disabled={!dbShow} />
                                                <label className="form-check-label">{t('platform.users.supervisor.create')}</label>
                                            </div>
                                        </div>
                                    </div>
                                     {/*<div className="accordion-item">
                                        <h2 className="accordion-header">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#bulk_senders" aria-expanded="false" aria-controls="bulk_senders">
                                                <i className="bi-send-plus nav-icon"></i> {t("components.aside.bulk-senders")}
                                                <span className="ms-3 opacity-75 fw-lighter">
                                                    {watch('settings.sends.show') ?  t('platform.users.supervisor.watch') + ', ' : ''}
                                                    {watch('settings.sends.actions') ? t('platform.users.supervisor.interactions') + ', ' : ''}
                                                    {watch('settings.sends.create') ?  t('platform.users.supervisor.download-export') : ''}
                                                </span>
                                            </button>
                                        </h2>
                                        <div id="bulk_senders" className="accordion-collapse collapse ps-5" data-bs-parent="#accordionFlushExample">
                                            <div className="form-check">
                                                <input className="form-check-input " type="checkbox"  {...register('settings.sends.show')} />
                                                <label className="form-check-label">{t('platform.users.supervisor.watch')}</label>
                                            </div>
                                            <div className="form-check">
                                                <input className="form-check-input" type="checkbox"  {...register('settings.sends.actions')} disabled={!sendsShow}/>
                                                <label className="form-check-label">{t('platform.users.supervisor.interactions')}</label>
                                            </div>
                                            <div className="form-check">
                                                <input className="form-check-input" type="checkbox"  {...register('settings.sends.create')} disabled={!sendsShow}/>
                                                <label className="form-check-label">{t('platform.users.supervisor.create')}</label>
                                            </div>
                                        </div>
                                    </div>*/}
                                    {/*<div className="accordion-item">
                                        <h2 className="accordion-header">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#follow-up" aria-expanded="false" aria-controls="follow-up">
                                                <i className="bi-chat-left-dots nav-icon"></i> {t("components.aside.follow-up")}
                                                <span className="ms-3 opacity-75 fw-lighter">
                                                    {watch('settings.followup.show') ? t('platform.users.supervisor.watch') + ', ' : ''}
                                                    {watch('settings.followup.actions') ? t('platform.users.supervisor.interactions') + ', ' : ''}
                                                    {watch('settings.followup.download') ? t('platform.users.supervisor.download-export') : ''}
                                                </span>
                                            </button>
                                        </h2>
                                        <div id="follow-up" className="accordion-collapse collapse ps-5" data-bs-parent="#accordionFlushExample">
                                            <div className="form-check">
                                                <input className="form-check-input " type="checkbox" {...register('settings.followup.show')} />
                                                <label className="form-check-label">{t('platform.users.supervisor.watch')}</label>
                                            </div>
                                            <div className="form-check">
                                                <input className="form-check-input" type="checkbox"  {...register('settings.followup.actions')} disabled={!followupShow} />
                                                <label className="form-check-label">{t('platform.users.supervisor.interactions')}</label>
                                            </div>
                                            <div className="form-check">
                                                <input className="form-check-input" type="checkbox"  {...register('settings.followup.download')} disabled={!followupShow} />
                                                <label className="form-check-label">{t('platform.users.supervisor.download-export')}</label>
                                            </div>
                                        </div>
                                    </div>*/}
                                    {/*<div className="accordion-item">
                                        <h2 className="accordion-header">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#config" aria-expanded="false" aria-controls="config">
                                                <i className="bi-gear nav-icon"></i> {t("components.aside.platform.config")}
                                                <span className="ms-3 opacity-75 fw-lighter">
                                                    {watch('settings.configuration.show') ? t('platform.users.supervisor.watch') + ', ' : ''}
                                                    {watch('settings.configuration.actions') ? t('platform.users.supervisor.interactions') + ', ' : ''}
                                                    {watch('settings.configuration.create') ? t('platform.users.supervisor.create') + ', ' : ''}
                                                    {watch('settings.configuration.download') ? t('platform.users.supervisor.download-export') : ''}
                                                </span>
                                            </button>
                                        </h2>
                                        <div id="config" className="accordion-collapse collapse ps-5" data-bs-parent="#accordionFlushExample">
                                        <div className="form-check">
                                                <input className="form-check-input " type="checkbox" {...register('settings.configuration.show')} />
                                                <label className="form-check-label">{t('platform.users.supervisor.watch')}</label>
                                            </div>
                                            <div className="form-check">
                                                <input className="form-check-input" type="checkbox"  {...register('settings.configuration.actions')} disabled={!configurationShow} />
                                                <label className="form-check-label">{t('platform.users.supervisor.interactions')}</label>
                                            </div>
                                            <div className="form-check">
                                                <input className="form-check-input" type="checkbox"  {...register('settings.configuration.create')} disabled={!configurationShow} />
                                                <label className="form-check-label">{t('platform.users.supervisor.create')}</label>
                                            </div>
                                            <div className="form-check">
                                                <input className="form-check-input" type="checkbox"  {...register('settings.configuration.download')} disabled={!configurationShow} />
                                                <label className="form-check-label">{t('platform.users.supervisor.download-export')}</label>
                                            </div>
                                        </div>
                                    </div>*/}
                                    {/*<div className="accordion-item">
                                        <h2 className="accordion-header">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#channels" aria-expanded="false" aria-controls="channels">
                                                <i className="bi-collection nav-icon"></i> {t("components.aside.platform.channels")}
                                                <span className="ms-3 opacity-75 fw-lighter">
                                                    {watch('settings.channels.show') ? t('platform.users.supervisor.watch') + ', ' : ''}
                                                    {watch('settings.channels.actions') ? t('platform.users.supervisor.interactions') + ', ' : ''}
                                                    {watch('settings.channels.create') ? t('platform.users.supervisor.create') + ', ' : ''}
                                                    {watch('settings.channels.download') ? t('platform.users.supervisor.download-export') : ''}
                                                </span>
                                            </button>
                                        </h2>
                                        <div id="channels" className="accordion-collapse collapse ps-5" data-bs-parent="#accordionFlushExample">
                                        <div className="form-check">
                                                <input className="form-check-input " type="checkbox" {...register('settings.channels.show')} />
                                                <label className="form-check-label">{t('platform.users.supervisor.watch')}</label>
                                            </div>
                                            <div className="form-check">
                                                <input className="form-check-input" type="checkbox"  {...register('settings.channels.actions')} disabled={!channelsShow} />
                                                <label className="form-check-label">{t('platform.users.supervisor.interactions')}</label>
                                            </div>
                                            <div className="form-check">
                                                <input className="form-check-input" type="checkbox"  {...register('settings.channels.create')} disabled={!channelsShow} />
                                                <label className="form-check-label">{t('platform.users.supervisor.create')}</label>
                                            </div>
                                            <div className="form-check">
                                                <input className="form-check-input" type="checkbox"  {...register('settings.channels.download')} disabled={!channelsShow} />
                                                <label className="form-check-label">{t('platform.users.supervisor.download-export')}</label>
                                            </div>
                                        </div>
                                    </div>*/}
                                    <div className="accordion-item">
                                        <h2 className="accordion-header">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#accounts" aria-expanded="false" aria-controls="accounts">
                                                <i className="bi-folder-plus nav-icon"></i> {t("components.aside.platform.accounts")}
                                                <span className="ms-3 opacity-75 fw-lighter">
                                                    {watch('settings.accounts.show') ? t('platform.users.supervisor.watch') + ', ' : ''}
                                                    {watch('settings.accounts.actions') ? t('platform.users.supervisor.interactions') : ''}
                                                </span>
                                            </button>
                                        </h2>
                                        <div id="accounts" className="accordion-collapse collapse ps-5" data-bs-parent="#accordionFlushExample">
                                            <div className="form-check">
                                                <input className="form-check-input " type="checkbox" {...register('settings.accounts.show')} />
                                                <label className="form-check-label">{t('platform.users.supervisor.watch')}</label>
                                            </div>
                                            <div className="form-check">
                                                <input className="form-check-input" type="checkbox"  {...register('settings.accounts.actions')} disabled={!accountsShow} />
                                                <label className="form-check-label">{t('platform.users.supervisor.interactions')}</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="accordion-item">
                                        <h2 className="accordion-header">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
                                                <i className="me-2 bi-people"></i> {t("components.aside.platform.users")}
                                                <span className="ms-3 opacity-75 fw-lighter">
                                                    {watch('settings.user.show') ? t('platform.users.supervisor.watch') + ', ' : ''}
                                                    {watch('settings.user.actions') ?  t('platform.users.supervisor.interactions') + ', ' : ''}
                                                    {watch('settings.user.create') ?  t('platform.users.supervisor.create') : ''}
                                                </span>
                                            </button>
                                        </h2>
                                        <div id="flush-collapseThree" className="accordion-collapse collapse ps-5" data-bs-parent="#accordionFlushExample">
                                            <div className="form-check">
                                                <input className="form-check-input " type="checkbox" {...register('settings.user.show')} />
                                                <label className="form-check-label">{t('platform.users.supervisor.watch')}</label>
                                            </div>
                                            <div className="form-check">
                                                <input className="form-check-input" type="checkbox"  {...register('settings.user.actions')} disabled={!userShow} />
                                                <label className="form-check-label">{t('platform.users.supervisor.interactions')}</label>
                                            </div>
                                            <div className="form-check">
                                                <input className="form-check-input" type="checkbox"  {...register('settings.user.create')} disabled={!userShow} />
                                                <label className="form-check-label">{t('platform.users.supervisor.create')}</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="accordion-item">
                                        <h2 className="accordion-header">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#payments" aria-expanded="false" aria-controls="payments">
                                                <i className="me-2 bi-credit-card-2-back"></i> {t("components.aside.platform.payments")}
                                                <span className="ms-3 opacity-75 fw-lighter">
                                                    {watch('settings.payments.show') ?  t('platform.users.supervisor.watch') + ', ' : ''}
                                                    {watch('settings.payments.actions') ? t('platform.users.supervisor.interactions') : ''}

                                                </span>
                                            </button>
                                        </h2>
                                        <div id="payments" className="accordion-collapse collapse ps-5" data-bs-parent="#accordionFlushExample" >
                                            <div className="form-check">
                                                <input className="form-check-input " type="checkbox"  {...register('settings.payments.show')} />
                                                 <label className="form-check-label">{t('platform.users.supervisor.watch')}</label>
                                            </div>
                                            <div className="form-check">
                                                <input className="form-check-input" type="checkbox"  {...register('settings.payments.actions')} disabled={!paymentsShow} />
                                                <label className="form-check-label">{t('platform.users.supervisor.interactions')}</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="accordion-item">
                                        <h2 className="accordion-header">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#chatbot" aria-expanded="false" aria-controls="chatbot">
                                                <i className="me-2 bi-robot"></i> {t("components.aside.platform.chatbot")}
                                                <span className="ms-3 opacity-75 fw-lighter">
                                                    {watch('settings.bots.show') ?  t('platform.users.supervisor.watch') + ', ' : ''}
                                                    {watch('settings.bots.create') ? t('platform.users.supervisor.create') : ''}
                                                </span>
                                            </button>
                                        </h2>
                                        <div id="chatbot" className="accordion-collapse collapse ps-5" data-bs-parent="#accordionFlushExample" >
                                            <div className="form-check">
                                                <input className="form-check-input " type="checkbox"  {...register('settings.bots.show')} />
                                                 <label className="form-check-label">{t('platform.users.supervisor.watch')}</label>
                                            </div>
                                            <div className="form-check">
                                                <input className="form-check-input" type="checkbox"   {...register('settings.bots.create')} disabled={!botsShow} />
                                                <label className="form-check-label">{t('platform.users.supervisor.create')}</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>}

                                {/* <div className="table-responsive datatable-custom">
                                    <table className="table table-thead-bordered table-nowrap table-align-middle table-first-col-px-0">
                                        <thead className="thead-light">
                                            <tr>
                                                <th>{t('platform.users.supervisor.module')}</th>
                                                <th className="text-center">{t('platform.users.supervisor.watch')}</th>
                                                <th className="text-center">{t('platform.users.supervisor.interactions')}</th>
                                                <th className="text-center">{t('platform.users.supervisor.create')}</th>
                                                <th className="text-center">{t('platform.users.supervisor.download-export')}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td><i className="me-2 bi-speedometer2"></i> Dashboard</td>
                                                <td className="text-center">
                                                    <div className="form-check form-check-inline m-0">
                                                        <input className="form-check-input" type="checkbox" {...register('settings.dashboard.show')} />

                                                    </div>
                                                </td>
                                                <td className="text-center">
                                                    <div className="form-check form-check-inline m-0">
                                                        <input className="form-check-input" type="checkbox"  {...register('settings.dashboard.actions')} disabled={!dashboardShow} />

                                                    </div>
                                                </td>
                                                <td className="text-center">
                                                    -
                                                </td>
                                                <td className="text-center">
                                                    <div className="form-check form-check-inline m-0">
                                                        <input className="form-check-input" type="checkbox"  {...register('settings.dashboard.download')} disabled={!dashboardShow} />

                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td><i className="me-2 bi-people"></i> Reportes</td>
                                                <td className="text-center">
                                                    <div className="form-check form-check-inline m-0">
                                                        <input className="form-check-input" type="checkbox" {...register('settings.reports.show')} />

                                                    </div>
                                                </td>
                                                <td className="text-center">
                                                    <div className="form-check form-check-inline m-0">
                                                        <input className="form-check-input" type="checkbox" {...register('settings.reports.actions')} disabled={!reportsShow} />

                                                    </div>
                                                </td>
                                                <td className="text-center">
                                                    -
                                                </td>
                                                <td className="text-center">
                                                    <div className="form-check form-check-inline m-0">
                                                        <input className="form-check-input" type="checkbox"  {...register('settings.reports.download')} disabled={!reportsShow} />

                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td><i className="me-2 bi-speedometer2"></i> Usuarios</td>
                                                <td className="text-center">
                                                    <div className="form-check form-check-inline m-0">
                                                        <input className="form-check-input" type="checkbox"  {...register('settings.user.show')} />

                                                    </div>
                                                </td>
                                                <td className="text-center">
                                                    <div className="form-check form-check-inline m-0">
                                                        <input className="form-check-input" type="checkbox" {...register('settings.user.actions')} disabled={!userShow} />

                                                    </div>
                                                </td>
                                                <td className="text-center">
                                                    <div className="form-check form-check-inline m-0">
                                                        <input className="form-check-input" type="checkbox" {...register('settings.user.create')} disabled={!userShow} />

                                                    </div>
                                                </td>
                                                <td className="text-center">
                                                    -
                                                </td>
                                            </tr>
                                            <tr>
                                                <td><i className="me-2 bi-gear"></i> Cuentas</td>
                                                <td className="text-center">
                                                    <div className="form-check form-check-inline m-0">
                                                        <input className="form-check-input" type="checkbox" {...register('settings.accounts.show')} />

                                                    </div>
                                                </td>
                                                <td className="text-center">
                                                    <div className="form-check form-check-inline m-0">
                                                        <input className="form-check-input" type="checkbox" {...register('settings.accounts.actions')} disabled={!accountsShow} />

                                                    </div>
                                                </td>
                                                <td className="text-center">
                                                    -
                                                </td>
                                                <td className="text-center">
                                                    -
                                                </td>
                                            </tr>
                                            <tr>
                                                <td><i className="me-2 bi-person-bounding-box"></i> Base de clientes</td>
                                                <td className="text-center">
                                                    <div className="form-check form-check-inline m-0">
                                                        <input className="form-check-input" type="checkbox"  {...register('settings.accounts_db.show')} />

                                                    </div>
                                                </td>
                                                <td className="text-center">
                                                    <div className="form-check form-check-inline m-0">
                                                        <input className="form-check-input" type="checkbox" {...register('settings.accounts_db.actions')} disabled={!dbShow} />

                                                    </div>
                                                </td>
                                                <td className="text-center">
                                                    <div className="form-check form-check-inline m-0">
                                                        <input className="form-check-input" type="checkbox"  {...register('settings.accounts_db.create')} disabled={!dbShow} />

                                                    </div>
                                                </td>
                                                <td className="text-center">
                                                    <div className="form-check form-check-inline m-0">
                                                        <input className="form-check-input" type="checkbox"  {...register('settings.accounts_db.download')} disabled={!dbShow} />

                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td><i className="me-2 bi-credit-card-2-back"></i> Pagos</td>
                                                <td className="text-center">
                                                    <div className="form-check form-check-inline m-0">
                                                        <input className="form-check-input" type="checkbox"  {...register('settings.payments.show')} />

                                                    </div>
                                                </td>
                                                <td className="text-center">
                                                    <div className="form-check form-check-inline m-0">
                                                        <input className="form-check-input" type="checkbox"  {...register('settings.payments.actions')} disabled={!paymentsShow} />

                                                    </div>
                                                </td>
                                                <td className="text-center">
                                                    -
                                                </td>
                                                <td className="text-center">
                                                    -
                                                </td>
                                            </tr>
                                            <tr>
                                                <td><i className="me-2 bi-robot"></i> Chatbot</td>
                                                <td className="text-center">
                                                    <div className="form-check form-check-inline m-0">
                                                        <input className="form-check-input" type="checkbox" {...register('settings.bots.show')} />

                                                    </div>
                                                </td>
                                                <td className="text-center">
                                                    <div className="form-check form-check-inline m-0">
                                                        <input className="form-check-input" type="checkbox" {...register('settings.bots.actions')} disabled={!botsShow} />

                                                    </div>
                                                </td>
                                                <td className="text-center">
                                                    <div className="form-check form-check-inline m-0">
                                                        <input className="form-check-input" type="checkbox"  {...register('settings.bots.create')} disabled={!botsShow} />

                                                    </div>
                                                </td>
                                                <td className="text-center">
                                                    -
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>*/}
                            </div>
                        </div>
                    </div>

                </div>
                <Footer />
            </main>


        </>
    )
}
export default SupervisorPermissionsPage